import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplateRefDiamondsService {
  private diamondsPopup: TemplateRef<any>;

  setDiamondsPopup(templateRef: TemplateRef<any>) {
    this.diamondsPopup = templateRef;
  }

  getDiamondsPopup(): TemplateRef<any> {
    return this.diamondsPopup;
  }
}
